import { render, staticRenderFns } from "./CardObjective.vue?vue&type=template&id=285c905a&"
import script from "./CardObjective.vue?vue&type=script&lang=js&"
export * from "./CardObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports